module.exports = __webpack_public_path__ + "static/media/icon_color_loading.7d5bdcbe.gif";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/icon_color_loading.gif
// module id = 687
// module chunks = 0